// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x80Y_LltA5PliUAZlphe {
  font-size: 1.5vmin;
  color: var(--text-light);
  text-align: center;
}

.j2nm2bSJThfb8Je8jDk0 {
  font-size: smaller;
  font-style: italic;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/UserLogOut/UserLogOut.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,wBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;AACJ","sourcesContent":[".UserLogOut {\n    font-size: 1.5vmin;\n    color: var(--text-light);\n    text-align: center;\n}\n\n.welcome {\n    font-size: smaller;\n    font-style: italic;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"UserLogOut": `x80Y_LltA5PliUAZlphe`,
	"welcome": `j2nm2bSJThfb8Je8jDk0`
};
export default ___CSS_LOADER_EXPORT___;
